import Image1 from '../../assets/testimonial1.png'
import Image2 from '../../assets/testimonial2.png'
import Image3 from '../../assets/testimonial3.png'


export const Data = [
  {
    id: 1,
    image: Image1,
    title: "John Meadow",
    description:
      "I am extremely satisfied with the Full Stack Development expertise of Oluwasegun! He took my project to new heights with his innovative solutions and flawless execution. His technical skills, professionalism, and dedication to delivering a successful outcome were truly impressive. I highly recommend Oluwasegun for any Full Stack Development project."
  },
  {
    id: 2,
    image: Image2,
    title: "Vanessa Clinton",
    description:
      "I had the pleasure of working with Oluwasegun as my Full Stack Developer, and I couldn't be happier with the results! His exceptional coding skills, ability to understand complex requirements, and prompt communication made the entire development process smooth and efficient. I would highly recommend Oluwasegun for any Full Stack Development work."
  },
  {
    id: 3,
    image: Image3,
    title: "Sara Cill",
    description:
      "Sara Cill is an exceptional Full Stack Developer who delivers outstanding results! Her deep understanding of both front-end and back-end technologies, combined with her creativity and attention to detail, resulted in a top-quality web application. I was impressed with Oluwasegun's commitment to excellence and his ability to meet project deadlines. I highly recommend him for any Full Stack Development project."
  },
];
